import { Serializable } from "models/Serializable";
import { WarehouseElementLocation } from "components/WarehouseElements/WarehouseElementsData";

export class EtiquetteInfos implements Serializable<EtiquetteInfos> {
  description!: string;

  etiquetteLocation!: WarehouseElementLocation;

  deserialize(input: any): EtiquetteInfos {
    this.description = input.description;
    this.etiquetteLocation = input.etiquetteLocation;
    return this;
  }

  static from(input: Partial<EtiquetteInfos>): EtiquetteInfos {
    return new EtiquetteInfos().deserialize(input);
  }
}
